import React from 'react';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import MyButton from '../UI/Button';

import ExcelJS from 'exceljs';
import { t } from 'i18next';
import { useSelector } from 'react-redux';

const m = [
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    "M",
    `M`,
    "M",
    "M",
    "M"
];

const headers = [
    "Посылка",
    "Коробка",
    "Общее кол-во",
    "Номер отслеживания (трек)",
    "Получатель",
    "Наименование товара",
    "Описание товара",
    "Цена",
    "Вес"
];

const headersAdmin = [
    "Посылка",
    "Коробка",
    "Общее кол-во",
    "Номер отслеживания (трек)",
    "Получатель",
    "Наименование товара",
    "Описание товара",
    "Цена",
    "Вес",
    "Электронная почта",
    "ИНН",
    "Номер телефона",
    "Адрес получателя",
    "Выбранный ПВЗ"
];
// Пример данных (можно загружать с сервера)
const headerDescriptions = [
    "General alphanumeric code generated by the merchant/cargo agent",
    "Customer name and surname",
    "Customer street, house, apartment number, strictly without commas",
    "Any other relevant information.",
    "Customer/Destination city.",
    "Customer/Destination region",
    "Customer/Destination zipcode",
    "For Russia – RU, for Kazakhstan – KZ, for Ukraine – UA",
    "In case of a single parcel put 1...",
    "Combined gross weight of all the parcels...",
    "Brief commodity description",
    "Commodity price in a currency agreed on...",
    "The country, where the commodity was produced...",
    "Harmonized Tariff Schedule code...",
    "Net weight of a single commodity inside a parcel",
    "Quantity of identical items in an order...",
    "Commodity detailed description...",
    "Commodity composition",
    "Customer email...",
    "Link to customer's web-page...",
    "Customer landline/alternative phone",
    "Customer cellphone number...",
    "Parcel barcode number (which is on a label) = order no.",
    "Delivery Type (choose a service...)",
    "Consignment/order barcode",
    "Indicates parcel's sequence number...",
    "Service code indicating service type",
    "Sender/Merchant code...",
    "Sender/Merchant's number...",
    "E-retailer comments if applicable",
    "Parcel in which the commodity is packed gross weight",
    "Sender/merchant name",
    "Sender/merchant address, e.g. country",
    "Sender/merchant address, e.g. city",
    "Sender/merchant address, e.g. region/state/district",
    "Sender/merchant address, e.g. street...",
    "Sender zipcode",
    "Sender/merchant country code, two letters only",
    "Customer national ID batch + number",
    "Customer national ID issue date",
    "Customer Full name as written in the ID in Cyrillic",
    "Digital indicator of the payment type...",
    "In case of indicator 1, means how much...",
    "PickPoint locker ID number...",
    "AWB Number",
    `VAT rate: 1-18%, 2-10%, 3-18/118, 4-10/110, 5-0%, 6-Free`,
    "Address of the issuing authority",
    "Taxpayer identification number (INN)",
    "Currency code (e.g. USD)"
];

const ExcelExport = ({ data }) => {
    const { auth } = useSelector(state => state.auth);
    const role = auth?.role ?? 'Админ';
    const handleExport = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Orders');


        // Заголовок
        if ((role == "Админ" || role == 'Менеджер')) {
            worksheet.addRow(headersAdmin);
        } else {
            worksheet.addRow(headers);
        }
        worksheet.getRow(1).eachCell(cell => {
            cell.font = { bold: true, color: { argb: 'FF000000' } };
            cell.alignment = { vertical: 'middle', horizontal: 'center' };
        });
        data.forEach(item => {
            if ((role == "Админ" || role == 'Менеджер')) {
                worksheet.addRow([
                    item.partial_code ?? '',         // Посылка
                    item.box_code ?? '',             // Коробка
                    item.total_count ?? 1,           // Общее кол-во
                    item.tracking_number ?? '',      // Номер отслеживания (трек)
                    (item.first_name ?? "") + " " + (item.last_name ?? ''),           // Получатель
                    item.category ?? '',                 // Наименование товара
                    item.description ?? '',          // Описание товара
                    item.amount ?? '',               // Цена
                    item.gross_weight ?? '',               // Вес
                    item.email ?? '',               // Вес
                    item.ppt_inn ?? '',               // Вес
                    item.phone ?? '',               // Вес
                    item.address ?? '',
                    item.pickup_point ?? item.prefer_pickup ?? "",               // Вес
                ]);

            } else {
                worksheet.addRow([
                    item.partial_code ?? '',         // Посылка
                    item.box_code ?? '',             // Коробка
                    item.total_count ?? 1,           // Общее кол-во
                    item.tracking_number ?? '',      // Номер отслеживания (трек)
                    (item.first_name ?? "") + " " + (item.last_name ?? ''),           // Получатель
                    item.category ?? '',                 // Наименование товара
                    item.description ?? '',          // Описание товара
                    item.amount ?? '',               // Цена
                    Number(parseFloat(item.gross_weight) || 0).toFixed(2) ?? '',               // Вес
                    item.email ?? '',               // Вес
                    item.ppt_inn ?? '',               // Вес
                    item.phone ?? '',               // Вес
                ]);
            }
        });
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });

        saveAs(blob, 'orders.xlsx');
    };

    return (
        <MyButton onClick={handleExport} label={"📦 " + t("downManif") + " (Excel file)"} >

        </MyButton>
    );
};

export default ExcelExport;
